/**
 * CORE-1479 — значок замка поверх наградной реакции, которая ещё не открыта.
 * Один на все ряды выбора, чтобы замок везде выглядел одинаково.
 *
 * Цвет — токен акцентных глифов CORE-1733, а не фирменный #E98245: тот на
 * светлых поверхностях палитры даёт 2.4:1 (возврат QA 23.10), а значку нужно
 * не меньше 3. Токен на вебе — #9A421F в светлой теме и #F0A06D в тёмной,
 * переключается вместе с темой; натив — прежний оранжевый, как у соседей.
 */
import React from 'react';
import { StyleSheet, View } from 'react-native';
import Ionicons from '@expo/vector-icons/Ionicons';
import { ACCENT_TEXT } from '../../styles/accentText';

export const RewardLock: React.FC<{ size?: number }> = ({ size = 11 }) => (
  <View style={styles.badge} pointerEvents="none">
    <Ionicons name="lock-closed" size={size} color={ACCENT_TEXT} />
  </View>
);

const styles = StyleSheet.create({
  badge: { position: 'absolute', right: 1, bottom: 1 },
});
